module.exports = __webpack_public_path__ + "img/logos_po-fesr-sicilia.52470ec7.jpg";